export default function StatusBadge({
	active,
	trueLabel = "Sí",
	falseLabel = "No",
	className = "",
	title,
}) {
	const label = active ? trueLabel : falseLabel;
	const badgeClassName = [
		"font-n",
		active ? "status status-ok" : "status status-none",
		className,
	]
		.filter(Boolean)
		.join(" ");

	return (
		<span className={badgeClassName} title={title || label}>
			{label}
		</span>
	);
}
